import { render } from "./Bug.vue?vue&type=template&id=b1c7d7e0"
import script from "./Bug.vue?vue&type=script&lang=js"
export * from "./Bug.vue?vue&type=script&lang=js"

import "./Bug.vue?vue&type=style&index=0&id=b1c7d7e0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__